import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

export default function StatsCard({
  title,
  value,
  icon: Icon,
  trend,
  trendValue,
  iconBgColor = 'bg-primary/10',
  iconColor = 'text-primary',
  isLoading = false,
  isRealtime = false,
}) {
  return (
    <div className="stats-card">
      <div className="flex items-start justify-between">
        <div className={`stats-card-icon ${iconBgColor}`}>
          <Icon className={`w-6 h-6 ${iconColor}`} />
        </div>
        {isRealtime && (
          <span className="flex items-center gap-1 text-xs text-success">
            <span className="w-2 h-2 bg-success rounded-full animate-pulse"></span>
            Live
          </span>
        )}
      </div>

      <div className="mt-4">
        {isLoading ? (
          <div className="h-8 w-20 bg-bg-secondary rounded animate-pulse"></div>
        ) : (
          <p className="text-2xl font-bold text-text-primary">
            {typeof value === 'number' ? value.toLocaleString() : value}
          </p>
        )}
        <p className="text-sm text-text-secondary mt-1">{title}</p>
      </div>

      {trend && trendValue && (
        <div className="mt-4 pt-4 border-t border-border">
          <div
            className={`flex items-center gap-1 text-sm ${
              trend === 'up' ? 'text-success' : 'text-danger'
            }`}
          >
            {trend === 'up' ? (
              <TrendingUp className="w-4 h-4" />
            ) : (
              <TrendingDown className="w-4 h-4" />
            )}
            <span className="font-medium">{trendValue}</span>
            <span className="text-text-muted ml-1">vs last period</span>
          </div>
        </div>
      )}
    </div>
  );
}
